import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=2c3dd412"
import script from "./InfoTable.vue?vue&type=script&lang=js"
export * from "./InfoTable.vue?vue&type=script&lang=js"
import style0 from "./InfoTable.vue?vue&type=style&index=0&id=2c3dd412&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports